export enum TmsRouteType {
  Undefined = 0,
  Bilateral = 1,
  Cabotage = 2,
  CrossTrade = 3,
  Transit = 4,
  PolishTransit = 5,
  Import = 6,
  Export = 7,
  CrossTradeBilateral = 8,
  CrossTradeWrong = 9,
  CabotageEmpty = 10,
  CrossTradeBilateralEmpty = 11,
  CrossTradeWrongEmpty = 12,
  Empty = 13,
  Domestic = 14,
}
